import React, { useEffect, useState } from "react";
import moment from "moment";
import { fetchJson, post } from "../../lib/Fetching";
import NotificationGroupForm from "./NotificationGroupForm";
import Button from "../Button";

export default function EditResultNotificationGroup({ id, clientView }) {
  const [show, setShow] = useState(false);
  const [group, setGroup] = useState(null);

  useEffect(
    () => {
      if (!show) return;
      fetchJson(
        "/result_notifications/result_notification_groups/" + id + ".json",
        group
      ).then((json) => {
        setGroup(json);
      });
    },
    [id, show]
  );

  const handleGroupSubmit = (group) =>
    post("/result_notifications/result_notification_groups", group)
      .then(
        (json) =>
          (window.location =
            "/result_notifications/result_notification_groups/" + json.result.id)
      )
      .catch((error) => alert(error));

  const toggle = () => setShow(!show);

  return (
    <div>
      <div style={{ textAlign: "left", paddingBottom: 20 }}>
        <Button
          icon="fa-edit"
          small
          title={show ? "Cancel" : "Edit Parameters"}
          onClick={toggle}
        />
      </div>
      {show &&
        group && (
          <div>
            <NotificationGroupForm
              newGroup={group}
              handleGroupSubmit={handleGroupSubmit}
              clientView={clientView}
            />
          </div>
        )}
    </div>
  );
}
